import React from 'react';
import { caseTypeArray } from 'Components/Client/Cases/CaseFormFields';

// Law firm "case types you take" - optional multi-select chips.
// Empty = all case types. Saved on the user as casePref, which is also the
// firm's default case filter and what the client pre-approve list matches on.
function CasePrefPicker({ value = [], onChange, label = 'Case types your firm takes', optional = true }) {
  const selected = Array.isArray(value) ? value : [];
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((v) => v !== id) : [...selected, id]);

  return (
    <div className='w-full font-plexsans'>
      <div className='flex items-baseline justify-between gap-3 mb-1'>
        <div className='font-semibold text-xs lg:text-sm text-navy'>
          {label}{optional && <span className='font-normal text-navy/[.5]'> (optional)</span>}
        </div>
        {selected.length > 0 &&
          <button type='button' onClick={() => onChange([])} className='text-[12px] text-brass underline cursor-pointer bg-transparent border-0 p-0'>Clear</button>}
      </div>
      <div className='text-[12px] leading-[1.5] text-navy/[.55] mb-2.5'>
        {selected.length === 0
          ? 'None selected means all case types. '
          : `${selected.length} selected. `}
        We use this as your default case filter and to show your firm to clients with matching cases.
      </div>
      <div className='flex flex-wrap gap-2'>
        {caseTypeArray.map((t) => {
          const on = selected.includes(t.id);
          return (
            <button
              key={t.id}
              type='button'
              aria-pressed={on}
              onClick={() => toggle(t.id)}
              className={`text-[12.5px] leading-none rounded-full py-2 px-3 border cursor-pointer transition-colors ${on ? 'bg-navy text-ivory border-navy font-semibold' : 'bg-white text-navy border-navy/[.18] hover:border-brass'}`}
            >
              {t.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default CasePrefPicker;
